import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import Icon from "@xo-union/tk-component-icons";
import { useUniqueID } from "@xo-union/react-unique-id";
import { compose, useClasses } from "@xo-union/react-css-modules";
import { DayPicker } from "react-day-picker";
import useDeprecatedWarning from "../../useDeprecatedWarning.js";
import Day from "../CustomDay/index.js";
import daypickerStyles from "../../css/daypicker-styles.css";
import daypickerOverrides from "../../css/daypicker-overrides.css";
import styles from "../../css/styles.css";
const IconRight = () => /*#__PURE__*/React.createElement(Icon, {
  size: "md",
  name: "caret_right"
});
const IconLeft = () => /*#__PURE__*/React.createElement(Icon, {
  size: "md",
  name: "caret_left"
});
const DatePicker = _ref => {
  let {
    daypickerClasses: daypickerClassesProp,
    classes: classesProp,
    numberOfMonths = 1,
    pagedNavigation = numberOfMonths > 1,
    fromYear = new Date().getFullYear() - 5,
    toYear = new Date().getFullYear() + 10,
    // Deprecated
    date,
    onDateChange,
    selected,
    onSelect,
    // Deprecated - End

    value,
    onChange,
    ...props
  } = _ref;
  const dayPickerClasses = useClasses(daypickerStyles, compose(daypickerOverrides), daypickerClassesProp);
  const classes = useClasses(styles, classesProp);
  const idNamespace = useUniqueID();
  const today = new Date();
  useDeprecatedWarning('`date`, `onDateChange`, `selected`, and `onSelect` are deprecated. Use `value` and `onChange`', [date, onDateChange, selected, onSelect]);
  const valueToUse =
  // eslint-disable-next-line no-nested-ternary
  typeof value === 'undefined' ? typeof selected === 'undefined' ? date : selected : value;
  return /*#__PURE__*/React.createElement("div", {
    className: classes['picker-container']
  }, /*#__PURE__*/React.createElement(DayPicker, _extends({
    showOutsideDays: true,
    fixedWeeks: true,
    mode: "single",
    captionLayout: "dropdown",
    fromYear: fromYear,
    toYear: toYear,
    numberOfMonths: numberOfMonths,
    pagedNavigation: pagedNavigation,
    defaultMonth: today,
    id: idNamespace,
    selected: valueToUse,
    onSelect: (dateState, selectedDay, activeModifiers, evt) => {
      if (typeof onDateChange === 'function') {
        onDateChange(dateState, selectedDay, activeModifiers, evt);
      }
      if (typeof onSelect === 'function') {
        onSelect(dateState, selectedDay, activeModifiers, evt);
      }
      if (typeof onChange === 'function') {
        // This is to resemble the upcoming union custom events API and begin moving people towards
        // using `evt.detail.value`
        onChange({
          detail: {
            value: dateState,
            selectedDay,
            activeModifiers
          },
          parentEvent: evt
        });
      }
    }
  }, props, {
    classNames: dayPickerClasses,
    components: {
      IconLeft,
      IconRight,
      Day
    }
  })));
};
export default DatePicker;